import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { ProjetIndicateurService } from '../../plananalytique/programme/projet-indicateur/projet-indicateur.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import * as FileSaver from 'file-saver';
@Component({
  selector: 'app-pta-service',
  standalone: false,
  templateUrl: './pta-service.component.html',
  styleUrl: './pta-service.component.scss'
})

export class PtaServiceComponent {

  annee: any;
  items: any = [];
  firstProjets: number = 0;
  rowsProjets: number = 10;
  totalRecords: number = 0;
  paginatedProjets: any = [];


  firstProjets1: number = 0;
  rowsProjets1: number = 1;
  totalRecords1: number = 0;
  paginatedProjets1: any = [];

  displayModalTaches: boolean = false;
  tacheItems: any = [];
  isLoadingModalTaches: boolean = false;
  firstTaches: number = 0;
  rowsTaches: number = 10;
  totalRecordsTaches: number = 0;
  paginatedTaches: any = [];
  currentDirectionId: any;
  currentServiceId: any;
  currentActiviteId: any;
  activiteLibelle: string;

  user: any;
  dateDebut: string;
  dateFin: string;
  directionItems: any = [];
  ptaItems: any = [];
  displayModal: boolean = false
  directionId: any;
  isLoading: boolean = false;
  isLoadingModal: boolean = false;
  @ViewChild('tepModal') modalContent: TemplateRef<any>;

  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private projetService: ProjetIndicateurService,
    private ngxService: NgxUiLoaderService,
    private router: Router
  ) {
    this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();
    const exercice = this.localstorage.getExerciceToUserToSuivieEvaluation();

    this.dateDebut = `${exercice}-01-01`;
    this.dateFin = new Date().toISOString().split('T')[0];

  }
  ngOnInit() {
    this.user = this.localstorage.getInfoUserToService()?.data;
    //console.log("  this.user", this.user);
    this.directionId = this.user?.service?.direction?.reference,
      this.getStatistique();
    this.getDirection();
  }
  getStatistique() {
    this.ngxService.start();
    const requestData = {
      annee: this.annee,
      service_id: this.user.service.id,
      user_reference: this.user.reference,
      type_operation: 'data',
      date_debut: this.dateDebut,
      date_fin: this.dateFin
    }
    this.paramservice.getStatistiqueprogrammeByService(requestData).subscribe(
      (response: any) => {

        this.items = response.data;
        this.totalRecords = this.items.length;
        this.updatePaginatedProjets();
        this.isLoading = false;
        this.ngxService.stop();
        ////console.log("this.actionData",this.serviceData);
      },
      (error: any) => {
        //console.log("une erreur est survenu", error);
        this.ngxService.stop()
      }

    );
  }
  onPageChangeProjets(event) {
    this.firstProjets = event.page * this.rowsProjets; // Mise à jour de la page actuelle
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.items.slice(start, end);
  }//end updatePaginatedProjets
  getDirection() {

    this.paramservice.fetchDataDirection().subscribe(

      (response: any) => {

        ////console.log("la reponse du webservice", response);

        this.directionItems = response.data;

      },
      (error) => {

        ////console.log("une erreur est survenu", error);

      }
    )
  }

  exportToDocument(typeDoc: any) {
    const requestData = {
      annee: this.annee,
      service_id: this.user.service.id,
      user_reference: this.user.reference,
      type_operation: typeDoc,
      date_debut: this.dateDebut,
      date_fin: this.dateFin
    }
    this.ngxService.start();


    this.paramservice.getStatistiqueprogrammeByServiceDocument(requestData).subscribe(
      (response: Blob) => {
        let filename = '';
        let mimeType = '';
        let successMessage = '';

        if (typeDoc === 'pdf') {
          filename = 'Statistiques_pta_service.pdf';
          mimeType = 'application/pdf';
          successMessage = 'Le fichier PDF a été téléchargé avec succès';

          const blob = new Blob([response], { type: mimeType });
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        } else {
          filename = 'Statistiques_pta_service.xlsx';
          mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          successMessage = 'Le fichier Excel a été téléchargé avec succès';

          const blob = new Blob([response], { type: mimeType });
          FileSaver.saveAs(blob, filename);
        }

        this.ngxService.stop();
        this.messageService.add({ severity: 'success', summary: 'Téléchargement réussi', detail: successMessage, life: 3000 });
      },
      (error) => {
        console.error('Une erreur est survenue', error);
        this.ngxService.stop();
      }
    );

  }
  closeModal() {
    this.displayModal = false;
  }

  serviceLibelle: any
  openModalActivitesService(item: any) {
    this.serviceLibelle = item.service.libelle
    this.currentDirectionId = item.service?.direction?.id || this.user?.service?.direction?.id;
    this.currentServiceId = item.service.id;
    this.displayModal = true
    this.isLoadingModal = true;
    this.firstProjets1 = 0;
    this.rowsProjets1 = 10;
    this.getPtaByService(item)
  }//en openModalActivitesService

  getPtaByService(item: any) {
    const requestData = {
      service_id: item.service.id,
      user_reference: this.user.reference,
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      type_operation: "data"
    }
    this.paramservice.getStatistiquePtaByService(requestData).subscribe(

      (response: any) => {

        this.ptaItems = response.data;
        this.totalRecords1 = this.ptaItems.length;
        this.updatePaginatedProjets1();
        this.isLoadingModal = false;
      },
      (error) => {

        ////console.log("une erreur est survenu", error);
        this.isLoadingModal = false;

      }
    )
  }
  onPageChangeProjets1(event) {
    //this.firstProjets1 = event.first;
    this.firstProjets1 = event.page * this.rowsProjets1;
    this.updatePaginatedProjets1();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets1() {
    const start = this.firstProjets1;
    const end = start + this.rowsProjets1;
    this.paginatedProjets1 = this.ptaItems.slice(start, end);

  }//end updatePaginatedProjets

  //detail taches par activite (service)
  openModalTachesByService(act: any) {
    this.activiteLibelle = act.activite.activite;
    this.currentActiviteId = act.activite.id;
    this.displayModalTaches = true;
    this.isLoadingModalTaches = true;
    this.firstTaches = 0;
    this.rowsTaches = 10;

    const requestData = {
      service_id: this.currentServiceId,
      activite_id: this.currentActiviteId,
      user_reference: this.user.reference,
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      type_operation: "data"
    };
    this.paramservice.getDetailTachesByService(requestData).subscribe(
      (response: any) => {
        this.tacheItems = response.data;
        this.totalRecordsTaches = this.tacheItems.length;
        this.updatePaginatedTaches();
        this.isLoadingModalTaches = false;
      },
      (error) => {
        this.isLoadingModalTaches = false;
      }
    );
  }

  closeModalTaches() {
    this.displayModalTaches = false;
  }

  onPageChangeTaches(event) {
    this.firstTaches = event.page * this.rowsTaches;
    this.updatePaginatedTaches();
  }

  updatePaginatedTaches() {
    const start = this.firstTaches;
    const end = start + this.rowsTaches;
    this.paginatedTaches = this.tacheItems.slice(start, end);
  }

  getAnnees(pdc: any): number[] {
    const anneesSet = new Set<number>();

    for (const act of pdc.details_pdc_activites || []) {
      for (const fin of act.details_pdc_financements_activites || []) {
        anneesSet.add(fin.annee);
      }
    }

    return Array.from(anneesSet).sort();
  }

  getMontantParAnnee(financements: any[], annee: number): number {
    const fin = financements?.find(f => f.annee === annee);
    return fin ? fin.montant : 0;
  }


}
